import * as React from 'react';
import { useSelector } from 'react-redux';
import './_coisErrors.scss';
import type { AxiosResponse } from 'axios';
import { useQueryClient, useQuery } from 'react-query';
import axios from 'axios';
import PrimayButton from 'shared-components/components/PrimayButton';
import type { RootState } from 'mainStore';
import type { Ipayload, Ierror } from './types';
import EmailTemplate from './emailTempalteCOIs/EmailTemplate';

export default function ErrorTemplateCOI(): JSX.Element {
  const [emailData, setEmailData] = React.useState<Ierror | null>(null);

  const currentBuilding = useSelector(
    (state: RootState) => state.workspaces.currentBuilding,
  );
  const { data: coisErrors } = useQuery(
    'get/cois-error',
    async () => axios({
      url: `/api/coise-errors-v2/?property=${currentBuilding.id}`,
      method: 'get',
    }),
    {
      enabled: Boolean(currentBuilding.id),
      select: (res: AxiosResponse<Ipayload>) => res.data.results,
    },
  );

  const queryClient = useQueryClient();
  React.useEffect(() => {
    if (emailData !== null) return;
    async function fetchData(): Promise <void> {
      await queryClient.invalidateQueries('get/cois-error').catch()
        .then();
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailData]);
  return (
    <>
      { !emailData && (
        <div className='coi-warning-container'>
          <div className='heading'>Deficient Certifications</div>
          <div className='certificates'>
            {coisErrors?.map((item) => (

              <div className='card'>
                <div className='title'>{item.insured}</div>
                <div className='rows'>

                  {item.errors.map((error) => (
                    <div className='warning-row'>
                      <div className='alert-sign'>
                        <i className='fas fa-exclamation-triangle' />
                      </div>
                      <div className='desc'>{error.error_text}</div>
                    </div>
                  ))}
                </div>
                <div className='bottom-line'>

                  <div className='button d-flex'>
                    <PrimayButton onClick={(): void => {
                      setEmailData(item);
                    }}
                    >
                      Send

                    </PrimayButton>
                  </div>
                  {item.sent_notes && <p>Notice Sent.</p> }

                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {emailData && <EmailTemplate emailData={emailData} setEmailData={(): void => { setEmailData(null); }} /> }
    </>
  );
}
